import { Component, Inject, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { APP_CONFIG } from './../../app.config';
import { IAppConfig } from './../../app.config.shared';


@Component({
  selector: 'app-regional-map',
  templateUrl: './regional-map.component.html',
  styleUrls: ['./regional-map.component.scss']
})
export class RegionalMapComponent implements OnInit {
  regionalMapJson: any;

  constructor(private _commonService: CommonService, 
    @Inject(APP_CONFIG) private config: IAppConfig, ) { }

  ngOnInit() {
    this._commonService.getData().subscribe(detailData => {
      if (detailData && detailData['collegeDetailSocialLocation'] && detailData['collegeDetailAtaGlance']) {
        this.regionalMapJson = 'https://www.google.com/maps/embed/v1/place?key=' + this.config.googleMapApiKey + '&q=' + encodeURIComponent(detailData['collegeDetailAtaGlance'].address + ' ' + detailData['collegeDetailAtaGlance'].city + ' ' + detailData['collegeDetailAtaGlance'].state);
      }
     });
  }

}
